import Auth from "helpers/auth";
import jstz from "jstimezonedetect";
import _ from "underscore";

import api from "@/helpers/api";
import bus from "@/helpers/bus";
import logger from "@/helpers/logger";
import Storage from "@/helpers/storage";

export default {
  state: {
    current: {
      id: null,
      name: "",
      formdata: {}
    }
  },

  mutations: {
    setCustomer(state, customer) {
      state.current = customer;
      // Persist customer ID for message continuity
      if (customer.id) {
        Storage.setItem("customerId", customer.id);
      }
    },

    setCustomerName(state, name) {
      state.current.name = name;
    },

    restoreCustomerFromStorage(state) {
      const customerId = Storage.getItem("customerId");
      if (customerId) {
        state.current.id = customerId;
      }
    }
  },

  actions: {
    fetchOrCreateCustomer({ dispatch }, callback) {
      const opts = {
        token: Auth.token(),
        callback
      };

      if (opts.token) {
        dispatch("fetchCustomer", opts);
      } else {
        dispatch("createCustomer", opts);
      }
    },

    fetchCustomer({ commit, dispatch, rootState }, opts) {
      logger.info("fetch customer");

      return api
        .instance()
        .get("/public/v1/customer")
        .then((resp) => {
          commit("setCustomer", resp.data.data.attributes);

          Auth.setName(resp.data.data.attributes.name);
          opts.callback(opts.token);
          return resp.data.data.attributes;
        })
        .catch((err) => {
          if (err.response && err.response.status === 401) {
            logger.info("fetch customer failed with 401, creating new customer");
            return dispatch("createCustomer", opts);
          }
          bus.$emit("connectionError", err, "Error fetching customer");
          throw err;
        });
    },

    createCustomer({ commit, rootState }, opts) {
      logger.info("create customer");

      const tz = jstz.determine().name();

      return api
        .instance()
        .post("/public/v1/customers", { timezone: tz, team_hashid: rootState.options.options.teamId })
        .then((resp) => {
          const attrs = resp.data.data.attributes;
          commit("setCustomer", attrs);

          Auth.setToken(attrs.session_token);
          Auth.setName(attrs.name);
          opts.callback(attrs.session_token);
          return attrs;
        })
        .catch((err) => {
          bus.$emit("connectionError", err, "Error creating customer");
          throw err;
        });
    },

    updateCustomerName({ commit, dispatch }, opts) {
      bus.$emit("connectPusher");

      return api
        .instance()
        .put(`/public/v1/conversations/${opts.conversation_id}/name`, {
          name: opts.name,
          skip_response: opts.skip_response || false
        })
        .then((resp) => {
          if (!_.isUndefined(opts.remember)) {
            Auth.setRememberMe(opts.remember);
          }

          const name = resp.data.data.attributes.formdata.customer_name;

          Auth.setName(name);
          commit("setCustomerName", name);
          dispatch("addMessage", { message: resp.data.included[0] });
          return resp.data;
        });
    },

    deleteCustomer({ commit }, opts) {
      const tz = jstz.determine().name();
      api.instance().delete("/public/v1/customer", { timezone: tz });
    },

    restoreFromStorage({ commit }) {
      commit("restoreCustomerFromStorage");
    },

    reset({ commit }, opts) {
      commit("setCustomer", opts.customer);
    }
  }
};
